import { IonButton, IonContent, IonPage, useIonRouter } from '@ionic/react'

import { PhoneKeypadInput } from '../../../../components/ui/phone-keypad-input'
import { CheckInWrapper } from '../../../../check-in/components/check-in-wrapper'
import { usePhoneCheckIn } from '../../../../check-in/utils'
import { RotateInfoIntro } from '../../../../rotate/components/rotate-info-intro'

function PhoneCheckInPage() {
  const router = useIonRouter()
  const { error, handleCheckIn, isLoading } = usePhoneCheckIn({
    addCustomerRedirect: '/check-in/paired/admin/add-customer',
    loyaltyRedirect: `/check-in/paired/admin/redeem-loyalty`,
  })

  function handleCancel() {
    router.canGoBack()
      ? router.goBack()
      : router.push('/check-in/paired/admin/home', 'back', 'pop')
  }

  return (
    <IonPage>
      <IonContent>
        <CheckInWrapper>
          <div className="flex flex-col items-center gap-y-3">
            <div className="flex items-center gap-x-3">
              <IonButton
                color="secondary"
                disabled={isLoading}
                onClick={handleCancel}
              >
                Cancel
              </IonButton>
              <IonButton
                disabled={isLoading}
                fill="solid"
                onClick={() =>
                  router.push(
                    `/check-in/paired/admin/email-check-in`,
                    'none',
                    'pop'
                  )
                }
              >
                Check-In With Email
              </IonButton>
            </div>
            <PhoneKeypadInput
              disabled={isLoading}
              onConfirm={handleCheckIn}
              altLabel="Check-In"
            />
            <div className="space-y-3 self-center text-center">
              <RotateInfoIntro>
                Enter phone number to check in customer.
              </RotateInfoIntro>
              {error ? <p className="text-ion-color-danger">{error}</p> : null}
            </div>
          </div>
        </CheckInWrapper>
      </IonContent>
    </IonPage>
  )
}

export { PhoneCheckInPage }
